// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 游戏（Games） ----------
const GAMES = [
  {
    id: "g_001",
    name: "王者征途",
    code: "kings_quest",
    category: "RPG / MMORPG",
    desc: "面向欧美东南亚市场的 MMORPG，2024 上线",
    status: "active",
    icon: "👑",
    color: "from-amber-400 to-orange-500",
    packages: 5,
    today: { share: 8234, click: 2341, install: 612, purchase: 89 },
    convert: 1.83,
    revenue: 22875,
  },
  {
    id: "g_002",
    name: "梦幻西游 Global",
    code: "fantasy_west",
    category: "策略 / 卡牌",
    desc: "回合制 RPG 出海版本，上线 18 个月",
    status: "active",
    icon: "🐉",
    color: "from-emerald-400 to-teal-500",
    packages: 3,
    today: { share: 6012, click: 1808, install: 445, purchase: 67 },
    convert: 2.1,
    revenue: 18450,
  },
  {
    id: "g_003",
    name: "Match Hero",
    code: "match_hero",
    category: "休闲 / 消除",
    desc: "三消休闲游戏，主打北美与拉美",
    status: "active",
    icon: "🍬",
    color: "from-pink-400 to-rose-500",
    packages: 4,
    today: { share: 12120, click: 3636, install: 1015, purchase: 78 },
    convert: 0.65,
    revenue: 4680,
  },
  {
    id: "g_004",
    name: "TankBlitz",
    code: "tank_blitz",
    category: "策略 / SLG",
    desc: "中重度 SLG，新接入测试",
    status: "draft",
    icon: "⚔️",
    color: "from-slate-400 to-slate-600",
    packages: 2,
    today: { share: 0, click: 0, install: 0, purchase: 0 },
    convert: 0,
    revenue: 0,
  },
];

export { GAMES };
